let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jT1Vf")).then(() => parcelRequire('hX8BJ'));